var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.blockClass},[_c('div',{attrs:{"id":"checkout"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }